<template>
  <v-container style="background-color: #F0F0EF; height: 535px; overflow: auto">
    <v-row>
      <v-col
        cols="6"
        sm="4"
        class="d-flex text-left flex-column"
        style="max-width: 240px"
      >
        <span class="search-title ">
          {{ $tc("UnscheduledTasks") }}
        </span>
        <div
          class="d-flex align-center justify-start mt-3 mr-1 flex-column "
          v-for="(user, i) of calendarUsers"
          :key="i"
        >
          <div
            class="d-flex align-center justify-start"
            style="width:100%;"
            v-if="
              tasksWithOwner.find(
                item => item.user_assignee_id === user && !item.scheduled_date
              )
            "
          >
            <v-avatar height="25" width="25"
              ><img :src="getImageUrl(user)" />
            </v-avatar>
            <h5>
              {{ getUserName(user) }}
            </h5>
          </div>

          <div v-for="(tasks, i) of tasksWithOwner" :key="i" class="ml-7">
            <v-card
              v-if="tasks.user_assignee_id === user && !tasks.scheduled_date"
              style="border: 1px solid #C9C9C9;"
              class="mb-2 mt-1"
              elevation="0"
              max-width="170"
              width="130"
              min-height="60"
              @click="addtoCalendar(tasks, user)"
            >
              <div
                style="padding: 5px; margin-bottom: -5px;"
                v-if="tasks.activityLabel"
              >
                <span
                  class="d-flex align-start task-text"
                  :title="tasks.activityLabel"
                >
                  {{ tasks.activityLabel }} - {{ $tc("Activity") }}</span
                >
                <div class="text-truncate task-text" :title="tasks.title">
                  <span>{{ tasks.title }}</span>
                </div>
              </div>

              <div style="padding: 5px; margin-bottom: -5px;" v-else>
                <span
                  class="d-flex align-start task-text"
                  :title="tasks.activityId"
                >
                  {{ getObjectTypeLabel(tasks.activityObject) }} - ID
                  {{ tasks.activityId }} - {{ $tc("Activity") }}</span
                >
                <div class="text-truncate task-text" :title="tasks.title">
                  <span>{{ tasks.title }}</span>
                </div>
              </div>

              <span
                :title="tasks.title"
                class="d-flex justify-end mr-1 estimated-time"
                >{{ tasks.execution_time }} min</span
              >
            </v-card>
          </div>
        </div>

        <div class="left-side"></div>
      </v-col>
      <v-col cols="12" sm="6" md="8">
        <v-row class="fill-height">
          <v-col>
            <v-sheet
              color="transparent"
              class="d-flex justify-start align-baseline"
            >
              <v-menu bottom :close-on-content-click="false" nudge-width="160">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="userId"
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="mb-1"
                  >
                    {{ getUserName(userId) }}</v-btn
                  >
                </template>
                <v-text-field
                  :placeholder="$tc('SearchUser')"
                  clearable
                  class="text-input-height"
                  color="accent"
                  v-model="searchUser"
                ></v-text-field>
                <v-list one-line dense height="167px" style="overflow: auto">
                  <template v-for="(user, i) in filteredUsers">
                    <v-list-item
                      :key="i"
                      dense
                      style="padding-left: 0px;"
                      @click="selectUser(user)"
                    >
                      <v-list-item-avatar
                        height="25px"
                        width="25px"
                        min-width="25px"
                      >
                        <v-img :src="getImageUrl(user)" sizes="small"></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-subtitle
                          v-html="getUserName(user)"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-menu>
              <span v-if="userId">&#8226;</span>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="text-size ml-2">{{
                    title
                  }}</span>
                </template>
                <v-date-picker
                  v-model="date"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-sheet>

            <calendar
              ref="calendar"
              :receivedEvents="events"
              :taskToAssign="taskToAssign"
              :choosenDate="date"
              @taskAdded="taskToAssignState"
              @updateTime="updateTime"
              @removeTask="removeTask"
              :disabledView="disabledView"
              :startDate="receivedData.start_date"
              :endDate="receivedData.end_date"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import _ from "lodash";
import { activitiesTasksDataMixin } from "../../../../mixins/field/activitiesTasksDataMixin";
import calendar from "./WorkOrderCalendar.vue";
import draggable from "vuedraggable";
export default {
  name: "WorkOrderSchedule",
  mixins: [activitiesTasksDataMixin],
  components: { calendar, draggable },
  props: {
    receivedData: {
      type: Object
    },
    disabledView: {
      type: Boolean
    }
  },
  data() {
    return {
      userId: null,
      searchUser: "",
      events: [],
      calendarUsers: [],
      taskToAssign: {},
      taskToAssignStatus: false,
      menu2: false,
      date: null,
      title: ""
    };
  },

  mounted() {
    this.calendarSelectedUsers();
    this.title = this.$refs.calendar.weekTitle;
    this.userId = this.calendarUsers[0];
  },
  updated() {
    this.title = this.$refs.calendar.weekTitle;
  },

  computed: {
    /**
     * @returns - sorted users, if user searches for a user, the list gets filtered.
     */
    filteredUsers() {
      return this.calendarUsers.filter(item => {
        let userName = this.getUserName(item);
        if (this.searchUser) {
          return userName.toLowerCase().match(this.searchUser);
        }
        return item;
      });
    },
    /**
     * gets all the tasks and adds properties necessary for vuetify calendar to work,
     * when user selects a diferent task it also updates the current array that is sent to the schedule.
     */
    tasksWithOwner() {
      let arr = [];
      let event = [];
      this.receivedData.activities.forEach(activity => {
        this.calendarSelectedUsers();
        activity.tasks.map(item => {
          item.start = new Date(item.scheduled_date).getTime();
          item.end = item.start + item.execution_time * 60000;
          item.timed = true;
          item.name = item.title;
          item.color = item.color ? item.color : "#4FA2B7";
          item.activityId = activity.id;
          item.activityLabel = activity.label;
          item.activityObject = activity.object_type;

          if (this.userId === item.user_assignee_id && item.scheduled_date) {
            event.push(item);
            this.events = [...new Set(event)];
          }
          if (!this.userId) {
            this.userId = item.user_assignee_id;
            this.events = [];
          }

          arr.push(item);
        });
      });
      return arr;
    }
  },
  /**
   * clears data sent to schedule whenever user is changed
   */
  watch: {
    userId() {
      this.events = [];
    }
  },

  methods: {
    removeTask(event) {
      let index = this.events.findIndex(item => item.id === event.id);
      this.events[index].scheduled_date = null;
    },
    /**
     * when user selects a task events is cleared and the userid is updated.
     */
    selectUser(user) {
      this.events = [];
      this.userId = user;
    },
    /**
     * when there is no task.id present (create mode) an id is created based on the date in milliseconds, the userid is also updated,
     * and the selected task is assigned to the tasktoassign data property, user clicks
     */
    addtoCalendar(task, user) {
      if (!task.id) {
        task.id = Date.now();
      }
      this.userId = user;
      this.taskToAssign = task;
    },
    /**
     * clears data when task is created in the schedule.
     */
    taskToAssignState(e) {
      if (e) {
        this.taskToAssign = {};
      }
    },
    /**
     * when task is created, it updates the properties on the selected task
     */
    updateTime(e) {
      this.receivedData.activities.forEach(item => {
        item.tasks.map(item => {
          if (item.id === e.id) {
            let start = new Date(e.start).toISOString();
            let estimatedTime = e.end - e.start;
            item.start = e.start;
            item.end = e.end;
            item.execution_time = estimatedTime
              ? estimatedTime / 1000 / 60
              : item.execution_time;
            item.scheduled_date = start;
          }
        });
      });
    },
    /**
     * a unique set of users is created, used in a v-for to then display each task inside each user.
     */
    calendarSelectedUsers() {
      let users = [];
      this.receivedData.activities.forEach(item => {
        item.tasks.forEach(item => {
          if (item.user_assignee_id) {
            users.push(item.user_assignee_id);

            this.calendarUsers = [...new Set(users)];
          } else if (item.company_id && item.user_assignee_id) {
            this.calendarUsers = [];
          }
        });
      });
    }
  }
};
</script>
<style scoped>
.left-side {
  border-left: 1px solid black;
  height: 395px;
  position: absolute;
  width: 1px;
  border-color: rgba(59, 59, 59, 0.212);
  top: 20px;
  left: 235px;
}
.search-title {
  font-size: 10px;
  color: #b8b8b7;
  font-weight: bold;
}
.v-list.v-sheet {
  text-align: left;
}
.v-list.v-sheet >>> .v-list-item__subtitle {
  font: normal normal normal 14px/18px Roboto;
  letter-spacing: 0.11px;
  color: #666666;
  opacity: 1;
}
.v-menu__content {
  background-color: white;
  padding: 5px;
}
.text-input-height >>> .v-text-field__details {
  display: none !important;
}
.v-input.text-input-height {
  padding-top: 0px;
}
.text-size {
  font-size: 13px;
}
.v-menu__content >>> .v-picker__title {
  display: none;
}
.task-text {
  text-align: left;
  font: normal normal normal 10px/24px Roboto;
  letter-spacing: 0.08px;
  color: #666666;
  opacity: 1;
}
.estimated-time {
  text-align: left;
  font: normal normal normal 8px/10px Roboto;
  letter-spacing: 0.06px;
  color: #c9c9c9;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/WorkOrderSchedule.vue